export default __webpack_public_path__ + "static/media/imovel.7f439657.jpg";